import { RadioGroupProps } from 'antd';
import { IFormFieldSchema } from '../../types';

export interface IRadioOption {
  label: string;
  value: string | number;
  children: IRadioOption[];
}

const DEFAULT_OPTIONS: IRadioOption[] = [
  { label: 'Option 1', value: '1', children: [] },
  { label: 'Option 2', value: '2', children: [] },
];

// prefer enum as source of truth, fallback to options, then default
// ensure the result is always an array
export const generateOptions = (
  props: Partial<IFormFieldSchema<RadioGroupProps>> | undefined
): IRadioOption[] => {
  const rawOptions = props?.enum || props?.['x-component-props']?.options;
  let options: IRadioOption[];

  if (Array.isArray(rawOptions)) {
    options = rawOptions.map(opt => {
      if (
        typeof opt === 'object' &&
        opt !== null &&
        'label' in opt &&
        'value' in opt
      ) {
        return {
          label: String(opt.label),
          value: opt.value,
          children: (opt as any)?.children || [],
        };
      }
      return {
        label: String(opt),
        value: opt,
        children: [],
      };
    });
  } else {
    options = DEFAULT_OPTIONS;
  }

  return options;
};
